<template>
<div class="OrderResult">
    <div class="steps">
        <div class="steps_box">
            <el-steps :active="active" finish-status="success" align-center>
                <el-step title="确认订单信息"></el-step>
                <el-step title="确认付款"></el-step>
                <el-step title="完成订购"></el-step>
            </el-steps>
        </div>
    </div>
    <div class="result">
        <div v-if="param.result === 'Y'" class="result_box success">
            <img :src="successImg">
            <div class="s_tips">
                <h3>支付成功</h3>
                <p>已完成高级版的订购，您可以进行更多的操作</p>
            </div>
            <div class="s_btns">
                <el-button @click="goBack">返回</el-button>
                <el-button type="primary" @click="goHome">进入首页</el-button>
            </div>
        </div>
        <div v-else class="result_box fail">
            <img :src="failImg">
            <div class="s_tips">
                <h3>支付失败</h3>
                <p>未完成版本的订购，请重新支付</p>
            </div>
            <div class="s_btns">
                <el-button @click="goBack">返回</el-button>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {queryOrderPayResult} from 'api/brandBusiness'
import {mapGetters, mapActions} from 'vuex'
import $ from 'jquery'
export default {
    name: 'OrderResult',
    data() {
        return {
            active: 3,
            successImg: require('@/common/images/service/success.png'),
            failImg: require('@/common/images/service/fail.png'),
            param: {
                orderno: this.$route.query.orderid,
                rid: this.$route.query.rid,
                result: this.$route.query.result,
                sign: this.$route.query.sign,
            },
            flag: this.$route.query.flag
        }
    },
    mounted() {
        if (!this.flag) this.getPayResultInfo()
    },
    methods: {
        getPayResultInfo() {
            this.setLoading(true)
            queryOrderPayResult({
                data: this.param,
                success: data => {
                    this.setLoading(false)
                    let obj = $.extend(true, {}, this.brandBusiness)
                    obj.expiredate = data.data.expireendtime
                    obj.expiredays = data.data.expiredays
                    this.setBrandBusiness(obj)
                    sessionStorage.setItem('brandBusiness', JSON.stringify(obj))
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        goBack() {
            this.$router.push({name: 'BBOrder'})
        },
        goHome() {
            this.$router.push({name: 'BBActivity'})
        },
        ...mapActions ([
            'setLoading', 'setBrandBusiness'
        ])
    },
    computed: {
        ...mapGetters(['brandBusiness'])
    }
}
</script>

<style lang="scss">
.OrderResult {
    background: #fff;
    height: 90vh;
    .steps {
        padding: 40px 30px 20px;
        .steps_box {
            /*width: 1080px;*/
            margin: 0 auto;
            .el-steps {
                .el-step {
                    .el-step__head {
                        .el-step__line {
                            top: 22px;
                        }
                        .el-step__icon {
                            width: 40px;
                            height: 40px;
                            .el-step__icon-inner {
                                font-size: 20px;
                                color: #303133;
                            }
                            .el-icon-check {
                                color: #409EFF;
                            }
                        }
                    }
                    .is-success {
                        color: #409EFF;
                        border-color: #409EFF;
                    }
                    .el-step__main {
                        .el-step__title {
                            font-size: 16px;
                            color: #303133;
                            font-weight: 500;
                        }
                        .is-success {
                            color: #409EFF;
                        }
                    }
                }
            }
        }
    }
    .result {
        margin-top: 60px;
        .result_box {
            display: flex;
            flex-direction: column;
            align-items: center;
            >img {
                display: inline-block;
                width: 72px;
                height: 72px;
            }
            .s_tips {
                text-align: center;
                h3 {
                    font-size: 24px;
                    color: #303133;
                    margin: 25px 0 10px;
                }
                p {
                    font-size: 14px;
                    color: #606266;
                }
            }
            .s_btns {
                margin-top: 40px;
                display: flex;
                justify-content: center;
            }
        }
    }
}
</style>
